<template>
  <AdminConfirmModal
    v-model="getAcceptRequestModal"
    :message="$t('Tariffs.sure_want_accept')"
    :confirm-text="$t('Default.accept')"
    @confirm="acceptRequest"
  />
</template>
<script>
import { ref } from "@vue/composition-api";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/admin/request/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentRequestInfo"],
  setup(props, { emit }) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getAcceptRequestModal = shortComputed(
      {
        storeType: "global",
        key: "getAcceptRequestModal",
      },
      GlobalMutationTypes.setAcceptRequestModal
    );

    const payload = ref({
      status: 2,
    });

    const acceptRequest = () => {
      store
        .dispatch(DispatchTypes.changeStatusRequest, {
          id: props.currentRequestInfo.id,
          payload: payload.value,
        })
        .then(() => {
          store.commit(GlobalMutationTypes.setAcceptRequestModal, false);
          emit("success");
          store.dispatch(DispatchTypes.getRequests, "?status=" + 1);
        });
    };
    return {
      store,
      getAcceptRequestModal,
      acceptRequest,
      userInfo,
      payload,
    };
  },
};
</script>
